import React from "react";
import "./styles.scss";

interface IProps {
  youTubeVideoId: string;
}

const VideoPlayer: React.FC<IProps> = (props) => (
  <div className="videoPlayer__outer">
    <div className="videoPlayer__inner">
      <iframe
        title="videoPlayer"
        className="videoPlayer__iframe hide-in-percy"
        frameBorder="0"
        // eslint-disable-next-line react/destructuring-assignment
        src={`https://www.youtube.com/embed/${props.youTubeVideoId}?modestbranding=1`}
      />
    </div>
  </div>
);

export default VideoPlayer;
